import { useUnsavedChanges } from '../../../hooks/use-unsaved-changes.jsx';

export const FormUnsavedConfirmationWrapper = ({ form, children }) => {
  const hasUnsavedChanges =
    !form.formState.isSubmitted &&
    !form.formState.isSubmitting &&
    form.formState.isDirty;
  useUnsavedChanges(
    hasUnsavedChanges,
    'Os dados que inseriu no formulário serão perdidos. Tem a certeza de que deseja sair da página?',
  );

  return children;
};
